/**
 * AllInventoryConfigs
 * All 6 config types on one page:
 *   - Products unit configurations (self-contained section)
 *   - Single merged table for Chemicals, Caps, Bottles, Labels, Supplies
 */

import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import { useSuppliers } from '../shared/useInventoryData';
import ProductsConfig from '../configuration-components/ProductsConfig';
import MergedConfigsTable from './all-inventory-config-components/MergedConfigsTable';

export default function AllInventoryConfigs({ companyId, canEdit = true, canDelete = true }) {
  const theme = useTheme();
  const { suppliers } = useSuppliers(companyId);

  return (
    <Box>
      {/* ── Products unit configurations ──────────────────────────────────── */}
      <Box sx={{
        mb: 4, pb: 4,
        borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.12)}`
      }}>
        <ProductsConfig companyId={companyId} canEdit={canEdit} canDelete={canDelete} />
      </Box>

      {/* ── Merged table: Chemicals, Caps, Bottles, Labels, Supplies ─────── */}
      <MergedConfigsTable companyId={companyId} suppliers={suppliers || []} canEdit={canEdit} canDelete={canDelete} />
    </Box>
  );
}
